<template>
  <span class="pega-break">
    <div class="boss-scout-confirm-container">
      <div
        class="boss-scout-confirm-header"
        data-test="label-subject"
      >件名：{{ subject }}
      </div>
      <div class="boss-scout-confirm-body pega-pre-wrap">
        <div class="boss-scout-confirm-contents">
          <div class="boss-scout-confirm-contents-text clearfix">
            <div
              class="boss-scout-confirm-contents-sentence float-left"
              data-test="text-body"
              v-html="$sanitize(renderBody)"
            />
          </div>
        </div>
      </div>
      <div
        v-if="message.files.length"
        class="pega-applicant-confirm-footer"
        data-test="confirm-files"
      >
        <div class="margin-bottom-1">
          添付ファイル
        </div>
        <div
          v-for="(file, i) in message.files"
          :key="i"
          class="position-relative"
        >
          <span :data-test="`confirm-file-${i}`">
            {{ file.name }}
          </span>
        </div>
      </div>
    </div>
    <div
      v-if="hasSchedule"
      data-test="candidate-block"
      class="boss-layout-block"
    >
      <div class="boss-table-2">
        <div class="boss-table-2-layout">
          <div class="boss-table-2-item boss-table-2-item-head">候補日時</div>
          <div
            class="boss-table-2-item boss-table-2-item-body boss-table-2-item-body-has-child"
          >
            <div class="boss-table-2-layout">
              <div
                class="boss-table-2-item boss-table-2-item-head boss-table-2-item-head-compact"
              >第一候補</div>
              <div
                class="boss-table-2-item boss-table-2-item-body js-check-default-cell"
              >
                <div class="boss-layout-block">
                  <div
                    class="boss-layout boss-layout-mobile-wrap boss-layout-start boss-layout-center"
                  >
                    <label data-test="label-candidate-date-1">{{ candidateDate(0) | parseDate }}</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="boss-table-2-layout">
              <div
                class="boss-table-2-item boss-table-2-item-head boss-table-2-item-head-compact"
              >第二候補</div>
              <div
                class="boss-table-2-item boss-table-2-item-body js-check-default-cell"
              >
                <div>
                  <div class="boss-layout-block">
                    <div
                      class="boss-layout boss-layout-mobile-wrap boss-layout-start boss-layout-center"
                    >
                      <label data-test="label-candidate-date-2">{{ candidateDate(1) | parseDate }}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="boss-table-2-layout">
          <div class="boss-table-2-item boss-table-2-item-head">場所</div>
          <div class="boss-table-2-item boss-table-2-item-body">
            <label data-test="label-place">{{ place }}
            </label>
          </div>
        </div>
        <div class="boss-table-2-layout">
          <div class="boss-table-2-item boss-table-2-item-head">所要時間</div>
          <div class="boss-table-2-item boss-table-2-item-body">
            <label data-test="label-duration">{{ duration | parseDuration }}</label>
          </div>
        </div>
        <div class="boss-table-2-layout">
          <div class="boss-table-2-item boss-table-2-item-head">
            内容（複数選択可能）
            <br>（任意）
          </div>
          <div class="boss-table-2-item boss-table-2-item-body width-100">
            <div>
              <div
                class="boss-layout boss-layout-start boss-layout-gap-large boss-layout-wrap"
              >
                <label data-test="text-contents">{{ interviewContents }}</label>
              </div>
            </div>
          </div>
        </div>
        <div class="boss-table-2-layout">
          <div class="boss-table-2-item boss-table-2-item-head">備考</div>
          <div class="boss-table-2-item boss-table-2-item-body pega-pre-wrap">
            <label data-test="text-remarks">{{ remarks }}</label>
          </div>
        </div>
      </div>
    </div>
    <div class="boss-layout-block">
      <div class="boss-table-wrap">
        <div class="boss-table-2">
          <div class="boss-table-2-layout boss-table-2-layout-half">
            <div class="boss-table-2-layout">
              <div class="boss-table-2-item boss-table-2-item-head">選考フェーズ</div>
              <div class="boss-table-2-item boss-table-2-item-body">
                <label data-test="label-phase">{{ phase }}</label>
              </div>
            </div>
          </div>
          <div class="boss-table-2-layout boss-table-2-layout-half">
            <div class="boss-table-2-layout">
              <div class="boss-table-2-item boss-table-2-item-head">選考ステータス</div>
              <div class="boss-table-2-item boss-table-2-item-body">
                <label data-test="label-status">{{ status }}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="boss-layout-block">
      <p class="boss-text">※「選考フェーズ、選考ステータス」は応募者側では表示されません。</p>
    </div>
    <div class="boss-button-container boss-button-container-entry-message">
      <div class="pega-entry-message-button">
        <div class="pega-entry-message-button-return-area">
          <button
            class="boss-button boss-button-return"
            type="button"
            data-test="button-back"
            @click="onBackClick"
          ><span class="boss-button-return-text">戻る</span></button>
        </div>
      </div>
      <div class="pega-entry-message-button">
        <button
          class="boss-button-center boss-button-confirm"
          type="button"
          data-test="button-submit"
          @click="$emit('submitted')"
        ><span class="boss-button-confirm-text">この内容で送信する</span></button>
      </div>
      <div class="pega-entry-message-button">
        <button
          class="boss-button-center boss-button-confirm"
          type="button"
          data-test="button-reserve"
          @click="$emit('reserved')"
        ><span class="boss-button-confirm-text">送信予約する</span></button><br>
        <span class="boss-annotation-text pega-entry-message-reservation-reserved-annotation">※土日を除き、翌日の10時から順次送信されます。</span>
      </div>
    </div>
  </span>
</template>

<script>
import { createDate } from '@/lib/dateUtils.js'
import _ from 'lodash'
import { mapGetters } from 'vuex'
import util from '@/lib/util'

export default {
  filters: {
    parseDate (val) {
      return createDate(val)?.format('YYYY年MM月DD日 HH:mm') ?? '指定なし'
    },
    parseDuration (val) {
      return (val) ? `${val} 分` : ''
    }
  },
  props: {
    message: {
      type: Object,
      required: true
    }
  },
  computed: {
    subject () {
      return _.get(this.message, 'subject', '')
    },
    body () {
      return _.get(this.message, 'body', '')
    },
    renderBody () {
      return util.replaceAddressAndUrlLink(this.body)
    },
    candidateDate () {
      return (index) => {
        return _.get(this.message, `schedule.candidateDates[${index}]`, '')
      }
    },
    place () {
      return _.get(this.message, 'schedule.place', '')
    },
    duration () {
      return _.get(this.message, 'schedule.duration', '')
    },
    interviewContents () {
      return _.compact([
        ..._.sortBy(_.get(this.message, 'schedule.contentIds', []))
          .map(v => { return _.get(_.find(this.interviewContentsMaster, { id: v }), 'name', '') }),
        !_.isEmpty(_.get(this.message, 'schedule.otherContents', ''))
          ? `その他（${this.message.schedule.otherContents}）`
          : ''
      ]).join('、')
    },
    hasSchedule () {
      return !!_.get(this.message, 'schedule')
    },
    remarks () {
      return _.get(this.message, 'schedule.remarks', '')
    },
    phase () {
      return (_.get(this.message, 'isPhaseChange', false)) ? _.get(_.find(this.phases, { id: _.get(this.message, 'phaseId') }), 'name', '') : '更新しない'
    },
    status () {
      return (_.get(this.message, 'isStatusChange', false)) ? _.get(_.find(this.allStatuses, { id: _.get(this.message, 'statusId') }), 'name', '指定なし') : '更新しない'
    },
    ...mapGetters([
      'interviewContentsMaster'
    ]),
    ...mapGetters('settings', [
      'phases',
      'allStatuses'
    ])
  },
  methods: {
    onBackClick () {
      this.$emit('back')
      this.$scrollTo('#message-register', 0, { offset: -35 })
    }
  }
}
</script>
